// extracted by mini-css-extract-plugin
module.exports = {"loginCodeInput":"TV_loginCodeInput__15hWL","loginCodeForm":"TV_loginCodeForm__18hMU","confirmButton":"TV_confirmButton__I4iZu"};